import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Client, TUser } from '../models/types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  constructor(private http: HttpClient) {}

  //#region User
  registerUser(user: any) {
    return this.http.post<TUser>('admin/user', user);
  }

  deleteUser(id: string) {
    return this.http.delete<TUser>(`admin/user/${id}`);
  }

  getUsers(clientId: string) {
    return this.http.get<TUser[]>(`admin/user/${clientId}`);
  }
  //#endregion

  //#region Client
  getClients(): Observable<Client[]> {
    return this.http.get<Client[]>('admin/client');
  }

  registerClient(label: string) {
    return this.http.post('admin/client' + `?label=${label}`, null);
  }

  deleteClient(clientId: string) {
    return this.http.delete('admin/client' + `?clientId=${clientId}`);
  }

  //#endregion

  //#region Merchant
  getMerchants(clientId: string) {
    return this.http.get<any[]>(`admin/merchant?clientId=${clientId}`);
  }

  registerMerchant(merchantRegister: any) {
    console.log(merchantRegister);
    return this.http.post('admin/merchant', JSON.stringify(merchantRegister), {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  deleteMerchant(clientId: string, merchantId: string) {
    return this.http.delete(`admin/merchant?clientId=${clientId}&merchantId=${merchantId}`);
  }
  //#endregion

  //#region Checkout
  getCheckouts(clientId: string, merchantId: string) {
    return this.http.get<any[]>(`admin/checkout?clientId=${clientId}&merchantId=${merchantId}`);
  }
  //#endregion

  //#region logs
  getLogs(startTime: Date, endTime: Date, type: string) {
    return this.http.get<any[]>(
      `admin/logs?startTime=${startTime.toISOString()}&endTime=${endTime.toISOString()}&type=${type}`,
    );
  }

  getMqttLogs(startTime: Date, endTime: Date, type: string) {
    return this.http.get<any[]>(
      `admin/mqtt?startTime=${startTime.toISOString()}&endTime=${endTime.toISOString()}&type=${type}`,
    );
  }
  //#endregion

  //#region Terminal
  getTerminals(merchantId: string, checkoutId: string) {
    return this.http.get<any>(`admin/terminal?merchantId=${merchantId}&checkoutId=${checkoutId}`);
  }

  clearTerminalStatus(merchantId: string, linker: string) {
    return this.http.get<any>(`admin/terminal/clear?merchantId=${merchantId}&linker=${linker}`);
  }
  //#endregion
}
